/* Copyright © 2026 YOUR GROWTH 365 (Jonas Brössel) — Proprietary. See LICENSE in repo root. */
/* =============================================================================
   VIEWS / UI / OVERLAY — Gemeinsame Modal-Overlay-Factory (S213-C-HF)
   =============================================================================
   Zweck: EIN dark-from-start-Overlay für alle App-Modals (Mail-Vorschau,
   Bon-/Z-Bon-PDF, künftige). Der weiße FOUC-Blitz entstand, weil neu erzeugte
   Overlays 1 Frame im Browser-Default (weiß) rendern konnten, bevor eine später
   greifende Klasse/Token den dunklen Grund setzte. Diese Factory rendert
   Overlay-Grund + Zentrierung INLINE ab Erzeugung dunkel (unabhängig von der
   Reihenfolge, in der styles.css/Tokens laden) und ergänzt die `.gg-overlay`-
   Klasse (styles.css) für Layout.

   Invariante (Memory gg-darkmode-invariants): nur Rahmen/Overlay-Grund ist
   dunkel — gewollt helle Papier-Inseln (Bon/Z-Bon/Speisekarte) setzen ihren
   eigenen hellen Grund im jeweiligen Container und bleiben hell.

   Der aufrufende Code baut den Panel-Inhalt (innerHTML) weiter selbst; die
   Factory liefert nur das dunkle Overlay-Gerüst + Backdrop-Close + ESC.
============================================================================ */

/**
 * Erzeugt ein dunkles Overlay-DIV (noch NICHT im DOM).
 *
 * @param {object} [opts]
 * @param {string} [opts.id]                DOM-id des Overlays
 * @param {string} [opts.className]         zusätzliche Klassen (neben `gg-overlay`)
 * @param {number|string} [opts.zIndex]     Stacking (Default: CSS `.gg-overlay`)
 * @param {() => void} [opts.onClose]       Backdrop-Klick + ESC → schließen
 * @returns {HTMLDivElement}
 */
export function createDarkOverlay(opts = {}) {
  const { id, className = '', zIndex, onClose } = opts;
  const overlay = document.createElement('div');
  if (id) overlay.id = id;
  overlay.className = ('gg-overlay ' + className).trim();
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  // Dark-from-start: Grund inline, damit selbst der allererste Frame dunkel ist
  // (bevor die .gg-overlay-Regel aus styles.css greift). Redundanz ist gewollt.
  overlay.style.background = 'var(--bg-overlay, rgba(0, 0, 0, .58))';
  if (zIndex != null) overlay.style.zIndex = String(zIndex);

  if (typeof onClose === 'function') {
    overlay.addEventListener('click', (e) => { if (e.target === overlay) onClose(); });
    const onKey = (e) => {
      if (e.key === 'Escape') { onClose(); document.removeEventListener('keydown', onKey); }
    };
    document.addEventListener('keydown', onKey);
    // Cleanup-Hook: der Aufrufer kann overlay._ggDetachKey() beim Schließen rufen,
    // falls das Overlay ohne onClose-Pfad entfernt wird.
    overlay._ggDetachKey = () => document.removeEventListener('keydown', onKey);
  }
  return overlay;
}
